import {ListingResult, ReportData, VehicleQueryParams} from '@shared/interfaces';
import {CarTitlePipe} from '@shared/pipes/car/car-title.pipe';

export const buildVehicleTitle = (report: ReportData | ListingResult, hasCondition?: boolean, hasTrim?: boolean,
                                  isReport?: boolean): string => {
  if (!report.carDetails) {
    return '';
  }
  const titlePipe = new CarTitlePipe();
  return titlePipe.transform(report, hasCondition, hasTrim, isReport);
};


export const vehicleQueryParams = (reportId: string, resultId: string, origin: 'aiChat' | 'report' = 'report'): VehicleQueryParams => {
  return {
    resultId,
    reportId,
    origin
  };
};


/**
 * Arrange listing by the listingIndex variable in each dictionary. Sometimes the listingIndex is not in order or
 * values in between are missing, this handles that properly.
 * @param {{[p: string]: ListingResult}} listings
 * @returns {ListingResult[]}
 */
export const arrangeListings = (listings: { [k: string]: ListingResult }): ListingResult[] => {
  const arrangedListings: ListingResult[] = [];
  const listingKeys = Object.keys(listings);
  const listingIndex = listingKeys.map(listingKey => listings[listingKey].listingIndex);
  listingIndex.sort((a, b) => a - b);
  for (const index of listingIndex) {
    for (const listingKey of listingKeys) {
      if (listings[listingKey].listingIndex === index) {
        arrangedListings.push(listings[listingKey]);
      }
    }
  }
  return arrangedListings;
};
